let tempUrl = 'https://getinked-w74fr6mhza-uc.a.run.app';

if (window.location.hostname === 'app.getporter.io') {
  tempUrl = 'https://api-4bpxtjez7q-uc.a.run.app';
}

const API_URL = process.env.REACT_APP_API_URL || tempUrl;
export default API_URL;
